import React from "react";

const Loader = () => {
  return (
    <>
      {/* <!-- ====================================== Page Loader ===================================== --> */}
      <div className="loader">
        <div className="shapes"></div>
      </div>
      {/* <!-- ====================================== Page Loader End===================================== --> */}
    </>
  );
};
export default Loader;
